import { render, staticRenderFns } from "./PageProduct.vue?vue&type=template&id=febbadb0&"
import script from "./PageProduct.vue?vue&type=script&lang=js&"
export * from "./PageProduct.vue?vue&type=script&lang=js&"
import style0 from "./PageProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports